import { z } from 'zod';
import { passwordValidationSchema } from '@lili/lili-frontend-common';
import { emailSchema } from '@Components/inputs/EmailInput';
import { OnboardingFormFields } from '@Types/index.ts';
import { getFirstNameScheme } from '@Components/inputs/FirstNameInput.tsx';
import { getLastNameScheme } from '@Components/inputs/LastNameInput.tsx';

export const welcomeScheme = z.object({
  [OnboardingFormFields.PASSWORD]: passwordValidationSchema,
  [OnboardingFormFields.EMAIL]: emailSchema,
});

const welcomeSchemeWithoutEmailValidation = z.object({
  [OnboardingFormFields.PASSWORD]: passwordValidationSchema,
  [OnboardingFormFields.EMAIL]: z.string(),
});

export const getWelcomeFormScheme = (
  shouldShowExtendedForm: boolean,
  isEmailPrefilled: boolean
) => {
  const personalDetails = z.object({
    ...getFirstNameScheme().shape,
    ...getLastNameScheme().shape,
  });

  if (isEmailPrefilled) {
    return shouldShowExtendedForm
      ? z.object({ ...welcomeSchemeWithoutEmailValidation.shape, ...personalDetails.shape })
      : welcomeSchemeWithoutEmailValidation;
  }
  return shouldShowExtendedForm
    ? z.object({ ...welcomeScheme.shape, ...personalDetails.shape })
    : welcomeScheme;
};
